// extracted by mini-css-extract-plugin
export default {"container":"ko-z"};